import Vue from 'vue'
import VueRouter from 'vue-router'
import HomeView from '../views/HomeView.vue'
import ApiView from '../views/pages/ApiView.vue'
import BotView from '../views/pages/BotView.vue'
import DashboardView from '../views/pages/DashboardView.vue'
import CronView from '../views/pages/CronView.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'home',
    component: HomeView
  },
  {
    path: '/api',
    name: 'api',
    component: ApiView
  },
  {
    path: '/bots',
    name: 'bots',
    component: BotView
  },
  {
    path: '/dashboards',
    name: 'dashboards',
    component: DashboardView
  },
  {
    path: '/cron',
    name: 'cron',
    component: CronView
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router
